<template>
    <div class="language-selector" :class="{'mr-3': $utils.isNotMobile()}">
        <v-menu :nudge-width="100" nudge-bottom="49">
            <template v-slot:activator="{ on }">
                <v-toolbar-title v-on="on" v-if="$utils.isMobile()">
                    <div class="m-item">{{$i18n.locale.toUpperCase().split('-')[0]}}</div>
                </v-toolbar-title>
                <v-toolbar-title v-on="on" v-else>
                    <v-layout align-center class="trigger-btn">
                        <v-icon dark>language</v-icon>
                        <span class="ml-1">{{mapLanguageValueToName[$i18n.locale]}}</span>
                    </v-layout>
                </v-toolbar-title>
            </template>
            <v-list>
                <v-list-tile
                    v-for="item in availableLanguages"
                    :key="item.value"
                    @click="changeLanguage(item.value)"
                >
                    <v-list-tile-title
                        v-text="item.text"
                        :class="{active: $i18n.locale === item.value}"
                    ></v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
    </div>
</template>
<script>
export default {
    name: 'LanguageSelector',
    data () {
        return {
            availableLanguages: this.$const.i18n.availableLanguages,
            mapLanguageValueToName: this.$const.i18n.mapLanguageValueToName
        }
    },
    mounted () {
        let language = this.$cookies.get(this.$const.LANGUAGE)
        if (!language) {
            language = this.getNavigatorLanguage()
        }
        if (this.mapLanguageValueToName[language]) {
            this.changeLanguage(language)
        }
    },
    methods: {
        changeLanguage (val) {
            this.$i18n.locale = val
            this.$cookies.set(this.$const.LANGUAGE, val)
        },
        getNavigatorLanguage () {
            if (navigator.languages && navigator.languages.length) {
                return navigator.languages[0]
            } else {
                return navigator.language || 'en-US'
            }
        }
    }
}
</script>
<style scoped lang="scss">
    .language-selector {
        color: #000;
        cursor: pointer;
    }

    .language-selector ::v-deep .v-toolbar__title {
        font-weight: normal;
        font-size: 14px;
        color: #fff;
    }

    .v-list__tile__title {
        color: #000;
    }

    .active {
        color: #649FDF;
    }

    .m-item {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        width: 34px;
        height: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
    }

    .trigger-btn {
        padding: 5px;
        border-radius: 5px;

        &:hover {
            background: #45b9ce;
        }
    }
</style>
